import { AppRoute } from "app/app-layout/constants/index";
import { NavCategoryId } from "app/app-layout/models/nav/nav-category-ids.enum";
import { NavItemPrimary } from "app/app-layout/models/nav/nav-item-primary.model";
import { NavItemSecondary } from "app/app-layout/models/nav/nav-item-secondary.model";
import { AppScopes } from "app/core/authentication/models/scopes.enum";

export class MyZoneNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: "$nav_primary_my_zone",
      categoryId: NavCategoryId.HOME,
      categoryIcon: "ico-logo-cz.svg",
      route: AppRoute.myZone,
      menuItems: [
        new DashboardNavItem(),
        new EquipmentNavItem(),
        new SurveyStartNavItem(),
      ],
    });
  }
}

export class DashboardNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$my_zone_nav_secondary_dashboard",
      scopes: [AppScopes.PERSONAL_DASHBOARD],
      route: AppRoute.dashboard,
      categoryId: NavCategoryId.HOME,
    });
  }
}

export class EquipmentNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$common_equipment",
      scopes: [AppScopes.MYZONE_EQUIPMENT_PERMISSION],
      route: AppRoute.equipment,
      categoryId: NavCategoryId.HOME,
    });
  }
}

export class SurveyStartNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$common_start_survey",
      scopes: [AppScopes.PERSONAL_DASHBOARD],
      route: AppRoute.survey,
      categoryId: NavCategoryId.HOME,
    });
  }
}
